import { createSelector } from 'reselect';
import get from 'lodash/get';
import { graphDataOrEmptyObjectSelector } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../HomePurchaseWorkflowConstants';

export const nullableMarketValueSelector = createSelector(
  graphDataOrEmptyObjectSelector,
  graphDataOrEmptyObject =>
    get(graphDataOrEmptyObject, `${HOME_PURCHASE_GOAL_GRAPH_NODE}.MarketValue`, null),
);

export const homeEstimatedValueIsValidSelector = createSelector(
  nullableMarketValueSelector,
  (nullableMarketValue) => {
    if (nullableMarketValue === null) {
      return false;
    }
    return true;
  },
);
